<style lang="less" scoped>
.user-view-wrap {
    display: flex;
    align-items: center;
}
.user-avatar {
  flex-shrink: 0;
  flex-grow: 0;
}
.userinfos {
  flex: 1;
  line-height: 20px;
  font-size: 14px;
  margin-left: 12px;
  .name {
    color: #333333;
    margin-bottom: 2px;
  }
  .other-info {
    color: #999;
    width: 100%;
    .info-item {
      position: relative;
      padding-right: 16px;
      &:last-child {
        padding-right: 0;
        &::after {
          display: none;
        }
      }
      &::after {
        position: absolute;
        top: 5px;
        right: 0px;
        content: "";
        width: 1px;
        height: 10px;
        background: #999;
        display: block;
        margin: 0 8px;
      }
    }
  }
}
.ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
</style>
<template>
  <div class="user-view-wrap">
    <div class='user-avatar'>
      <component :is="createAvatar({ class: 'user-avatar', label: userInfo.name, src: userInfo.pic, size: 36, backgroundColor: userInfo.pic ? 'transparent' : '#eb8f3b' })"></component>
    </div>
    <div class="userinfos ellipsis">
      <div class="name">{{ userInfo?.name }}</div>
      <div class="other-info ellipsis flex">
        <!-- 部门 -->
        <span class="info-item ellipsis" v-if="userInfo?.deptNames?.length">
          <span class="info-item-content">
            <span class="info-item-values ellipsis">{{ userInfo?.deptNames?.join('，') }}</span>
          </span>
        </span>
         <!-- 关系 -->
        <span class="info-item ellipsis flex-keep-width" v-if="userInfo?.invitationCode">
          <span class="info-item-content">
            <span class="info-item-values ellipsis">{{ getRelationsByCode(userInfo?.invitationCode) }}</span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { toRefs } from 'vue'
import { createAvatar } from '@/utils'
import { getRelationsByCode } from '@/pages/performance/utils/annular'
const props = defineProps(['userInfo'])
const { userInfo } = toRefs(props)
</script>
